<script setup lang="ts">
import type { FilterOption } from '@/types/filter.types'
import LikedClassList from './LikedClassList.vue'
import PurchasedClassList from './PurchasedClassList.vue'

// props로 현재 선택된 필터 받기
const props = defineProps<{
  selectedCategory: FilterOption
}>()
</script>

<template>
  <div class="my-class-list-section">
    <!-- 구매한 강좌 표시 -->
    <PurchasedClassList v-if="props.selectedCategory.data === 'purchased'" />

    <!-- 찜한 강좌 표시 -->
    <LikedClassList v-else />
  </div>
</template>

<style scoped>
.my-class-list-section {
  width: 100%;
}
</style>
